import styled, { css } from 'styled-components';
import { ColorAddiBackgroundSoft, ColorAddiPrimaryActive, ColorAddiGrayBase, ColorAddiCompFiveLighten4 } from '@addi/foundation/dist/web/colors';
import { Layer } from '../../layer';
export const CardContainer = styled(Layer) `
    border-width: ${({ selected, border }) => selected ? 3 : (border ? border : 1)}px;
    border-color: ${({ selected }) => selected ? ColorAddiPrimaryActive : ColorAddiBackgroundSoft};
    border-radius: ${({ radius }) => radius ? radius : 4}px;
    padding: ${({ verticalPadding, horizontalPadding }) => `${verticalPadding ? verticalPadding : 0}px ${horizontalPadding ? horizontalPadding : 0}px`} ;

    &:hover {
        background-color: ${ColorAddiCompFiveLighten4};
    }

    ${({ disabled }) => disabled
    && css `
            border-width: 1px;
            border-color: ${ColorAddiGrayBase};
            background-color: ${ColorAddiBackgroundSoft};
        `}
`;
//# sourceMappingURL=CardContainer.styled.js.map